import { useEffect, useRef, useState } from 'react'

type InViewOptions = {
    once?: boolean
    rootMargin?: string
    threshold?: number
}

export const useInView = <T extends Element>({
    once = true,
    rootMargin = '0px 0px -10% 0px',
    threshold = 0
}: InViewOptions = {}) => {
    const ref = useRef<T | null>(null)
    const [inView, setInView] = useState(false)

    useEffect(() => {
        const element = ref.current

        if (!element) return

        if (typeof IntersectionObserver === 'undefined') {
            setInView(true)
            return
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true)
                if (once) observer.disconnect()
            }
            else if (!once) {
                setInView(false)
            }
        }, { rootMargin, threshold })

        observer.observe(element)

        return () => observer.disconnect()
    }, [once, rootMargin, threshold])

    return { ref, inView }
}
